import { HomeItemType } from 'src/app/types';
import { HomeProductStatus } from 'src/consts';

export const medicationItems = [
  {
    id: '1234',
    firstName: 'Sam',
    lastName: 'Test',
    isPrimary: true,
    name: 'Lisinopril',
    status: HomeProductStatus.PROCESSING_ORDER,
    statusText: '',
    instructions: '',
    type: HomeItemType.prescription,
    source: 'doctor',
    dosage: '10mg',
    quantity: '30 tablets',
    nextRefillDate: '01/01/2022',
    ndc: '000000022',
    refillsRemaining: 3,
    refillStatusText: '3 REFILLS',
    refillStatus: {
      status: '',
      showNewBadge: false,
    },
    inBagRefillStatusText: 'dfsdf',
    prescriptionFulfillmentId: '123132123',
    priceInDollars: 10,
    patientMedicationId: 123453,
    medicationId: '234234',
    expirationDate: '01/01/2022',
    showPrice: false,
    patientName: 'Same',
    showArchivedCTA: false,
    insuranceApplied: true,
    prescribedDate: '01/01/2024',
    prescriptionLifecycle: null,
    retrieval: '',
  },
  {
    id: '5678',
    firstName: 'Sam',
    lastName: 'Test',
    isPrimary: true,
    name: 'Bupropion XL',
    status: HomeProductStatus.PROCESSING_ORDER,
    statusText: '',
    instructions: '',
    type: HomeItemType.prescription,
    source: 'doctor',
    dosage: '150mg',
    quantity: '30 tablets',
    nextRefillDate: '01/01/2022',
    ndc: '0000004543',
    refillsRemaining: 1,
    refillStatusText: '1 REFILL',
    refillStatus: {
      status: '',
      showNewBadge: false,
    },
    inBagRefillStatusText: 'dfsdf',
    prescriptionFulfillmentId: '123132123',
    priceInDollars: 10,
    patientMedicationId: 123453,
    medicationId: '234234',
    expirationDate: '01/01/2022',
    showPrice: false,
    patientName: 'Same',
    showArchivedCTA: false,
    insuranceApplied: true,
    prescribedDate: '01/01/2024',
    prescriptionLifecycle: null,
    retrieval: '',
  },
];
